import type { TOC } from '@ember/component/template-only'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import type RexAwardsEarnedRoute from 'teacher-ui-client/reporting/ui-scope/rex/awards-earned/route'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { not } from 'ember-truth-helpers'
import { TrophiesTotals } from 'teacher-ui-client/components/giraffe/charts/awards-earned/trophies/totals'
import { TrophiesHistory } from 'teacher-ui-client/components/giraffe/charts/awards-earned/trophies/history'
import { camelize } from '@ember/string'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import IsSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { concat } from '@ember/helper'

interface Signature {
  Args: {
    model: ModelFor<RexAwardsEarnedRoute>
  }
}

export const ReportingRexAwardsEarnedPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.awardsEarned.rex"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.awardsEarnedTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.rex.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.awardsEarnedTotals}}>
    {{#each @model.awardsEarnedTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 relative my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <TrophiesTotals
          @data={{gradeData}}
          @title={{t "reporting.chartTitles.awardsEarnedTotals.rex"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.awardsEarnedTotals." (camelize @model.uiScope.scope))}}
          @grade={{fullGradeName gradeData.grade_position}}
          @yAxisTitle={{t "reporting.chartTitles.awardsEarnedTotals.rex"}}
        />
        <span class="absolute top-0 right-1 print:hidden">
          <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-4 w-4 cursor-pointer" />
          <Tooltip @text={{t "reporting.tooltips.awardsEarnedTotals.rex" htmlSafe=true}} />
        </span>
      </div>
    {{/each}}

    {{#if @model.awardsEarnedHistory}}
      <TrophiesHistory
        @data={{@model.awardsEarnedHistory}}
        @students={{@model.scopedStudents}}
        @subco={{(IsSubco)}}
        @uiScope={{@model.uiScope.scope}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReportingRexAwardsEarnedPage)
